module.exports = __webpack_public_path__ + "static/media/jpg-icon.bc1d4e76.svg";